import Vue from 'vue';
import VueRouter from 'vue-router';
import { createBaseRoutes, createRouterGuard, createTitleGuard } from '@shared/router/createBaseRoutes';
import config from './config';
import store from './store';
import Projects from './views/Projects.vue';
import Start from './views/Start.vue';
import Wizard from './views/Wizard.vue';
import Results from './views/Results.vue';
import ProjectDetail from './views/ProjectDetail.vue';
import Approvals from './views/Approvals.vue';
import Posts from './views/Posts.vue';
import Connections from './views/Connections.vue';
import ConnectCallback from './views/ConnectCallback.vue';
import Help from './views/Help.vue';
import AdminPublishing from './views/AdminPublishing.vue';
import AdminSupport from './views/AdminSupport.vue';
import AdminQuality from './views/AdminQuality.vue';
import Settings from './views/Settings.vue';
import AcceptReviewer from './views/AcceptReviewer.vue';

Vue.use(VueRouter);
const title = name => name + ' | ' + config.PRODUCT_NAME;
const member = { requiresAuth: true, allowWhenUnpaid: true };
// Work that costs money: a paid-only site sends members without a plan to the plan picker first,
// and back here after checkout.
const work = { requiresAuth: true };
const routes = [
  { path: '/', name: 'Projects', component: Projects, meta: { ...member, title: title('Projects') } },
  // The landing's URL box opens this page. With free samples on, guests get a session and a sample;
  // on a paid-only site visitors create an account and choose a plan first, keeping the link.
  { path: '/start', name: 'Start', component: Start, meta: { ...work, allowAnonymous: true, title: title('Get started') } },
  { path: '/create', name: 'Create', component: Wizard, meta: { ...work, title: title('Create posts') } },
  { path: '/create/:id/:step(source|formats|review|accounts|publish)', name: 'Wizard', component: Wizard,
    meta: { ...work, allowAnonymous: true, title: title('Create posts') } },
  { path: '/create/:id/results/:group', name: 'Results', component: Results, meta: { ...member, title: title('Publishing') } },
  { path: '/projects/:id', name: 'Project', component: ProjectDetail, meta: { ...member, title: title('Project') } },
  { path: '/approvals', name: 'Approvals', component: Approvals, meta: { ...member, title: title('Approvals') } },
  { path: '/posts', name: 'Posts', component: Posts, meta: { ...member, title: title('Posts') } },
  { path: '/connections', name: 'Connections', component: Connections, meta: { ...member, title: title('Connections') } },
  { path: '/connections/callback', name: 'ConnectCallback', component: ConnectCallback, meta: { ...member, title: title('Connecting') } },
  { path: '/help', name: 'Help', component: Help, meta: { ...member, title: title('Help') } },
  // The shared FAQ page describes the reference app; this app's answers are on Help.
  { path: '/faq', redirect: '/help' },
  { path: '/settings', name: 'Settings', component: Settings, meta: { ...member, title: title('Settings') } },
  { path: '/reviewer/accept', name: 'AcceptReviewer', component: AcceptReviewer, meta: { ...member, title: title('Review invitation') } },
  { path: '/admin/publishing', name: 'AdminPublishing', component: AdminPublishing,
    meta: { ...member, requiresAdmin: true, title: title('Publishing controls') } },
  { path: '/admin/support', name: 'AdminSupport', component: AdminSupport,
    meta: { ...member, requiresAdmin: true, title: title('Support') } },
  { path: '/admin/quality', name: 'AdminQuality', component: AdminQuality,
    meta: { ...member, requiresAdmin: true, title: title('Quality review') } },
  ...createBaseRoutes(config)
];
const router = new VueRouter({ mode: 'history', routes, scrollBehavior() { return { x: 0, y: 0 }; } });
router.beforeEach(createRouterGuard(store, config));
router.afterEach(createTitleGuard(config));
export default router;
